import { ShareDrawer as InvoiceReportShareDrawerImpl } from '@/features/invoice_reports/components/ShareDrawer';
import { r2wc } from '@/wc/helper/render';
import { ToastProvider, useToast } from '@moneyforward/ap-frontend-components';
import { useEffect, useState } from 'react';

type Props = {
  reportId: string;
  sharePath?: string;
};

// Rails pages open/close this via an `invoice-report-share-drawer-open`
// window CustomEvent (same pattern as DetailApPayeeDrawer) since r2wc
// attributes can't carry an onClose callback across the custom element
// boundary.
const InvoiceReportShareDrawerWithOpenEvent = ({
  reportId,
  sharePath,
}: Props) => {
  // The r2wc Provider has no ToastProvider (only pages/_app.tsx does), so the
  // add/remove viewer toasts need their own holder, same as PayeeDetailDrawer.
  const [toastApi, toastContextHolder] = useToast();
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);

  useEffect(() => {
    const handleOpen = () => setOpen(true);
    window.addEventListener('invoice-report-share-drawer-open', handleOpen);
    return () =>
      window.removeEventListener(
        'invoice-report-share-drawer-open',
        handleOpen
      );
  }, []);

  return (
    <ToastProvider value={toastApi} contextHolder={toastContextHolder}>
      <InvoiceReportShareDrawerImpl
        open={open}
        onClose={onClose}
        reportId={reportId}
        sharePath={sharePath}
        onCloseDetailDrawer={onClose}
      />
    </ToastProvider>
  );
};

export const InvoiceReportShareDrawer = r2wc(
  InvoiceReportShareDrawerWithOpenEvent,
  {
    shadow: 'open',
    props: {
      reportId: 'string',
      sharePath: 'string',
    },
  }
);
